module.exports = __webpack_public_path__ + "images/mdj/members/resume/common/common_icon07-eefd2f9e8168117ac08b12f09f8d61c0.png";